export default __webpack_public_path__ + "static/media/33.f6f4c37a.mp3";